<template>
    <p class="disclaimer"> {{ $t("disclaimer.syc") }} </p>
</template>

<script>
export default {
    name: "SellYourCarDisclaimer"
}
</script>
